import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import Search from "@/design/components/Search";
import useSearch from "@/utils/hooks/useSearch";
import Valkyrie, { viPlus, viXmark } from "@sippy-platform/valkyrie";

import { Box, Drawer, IconButton, List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import AddMemberItem from "./AddMemberItem";

function AddMemberFlyout({ queue, setQueue }) {
  const queueMembersStore = useSelector((state) => state.domain.queueMembers);

  // Drawer
  const [drawer, setDrawer] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const searchResults = useSearch(queueMembersStore.list, searchValue, ["attributes.name", "attributes.exten"]);

  const closeDrawer = useCallback(() => {
    setDrawer(undefined);
    setSearchValue("");
  }, []);

  return (
    <>
      <IconButton sx={{ ml: "auto" }} onClick={() => setDrawer(true)}>
        <Valkyrie icon={viPlus} />
      </IconButton>
      <Drawer
        open={!!drawer}
        onClose={() => closeDrawer()}
        anchor="right"
        slotProps={{
          paper: {
            sx: (theme) => ({ maxWidth: 320, width: 1, p: 1.5, display: "flex", gap: 1, ...theme.scrollbar }),
            elevation: 4,
          },
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Manage members</Typography>
          <IconButton onClick={() => closeDrawer()} color="inherit">
            <Valkyrie icon={viXmark} />
          </IconButton>
        </Stack>
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000 }}>
          <Search blur value={searchValue} onChange={setSearchValue} />
        </Box>
        <List>
          {searchResults.length >= 1 ? (
            searchResults.map((member) => (
              <AddMemberItem key={member.id} member={member} queue={queue} setQueue={setQueue} />
            ))
          ) : (
            <ListItem>
              <ListItemText primary="There are no queue members available..." />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
}

AddMemberFlyout.propTypes = {
  queue: PropTypes.object,
  setQueue: PropTypes.func,
};

export default AddMemberFlyout;
